import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ButtonSubmit, Form } from '@anytag/shared-atoms';
import { useUserRoles } from '@anytag/auth';
import { NoticeSignUpUrl, NoticeConnectUrl, NoticeUseChromeExtension } from '../shared';
import { InfluencerFormValues } from './schema-types';
import {
  PostsPriceSection,
  SocialAccountsSection,
  InfluencerMemoSection,
  InfluencerAccountSection,
  InfluencerManagersSection,
  PaymentInformationSection,
  AddressInformationSection,
  BrandContentPermissionsSection
} from './sections';

export const Template = () => {
  const { t } = useTranslation();
  const { isPartner } = useUserRoles();
  const {
    watch,
    formState: { isSubmitting }
  } = useFormContext<InfluencerFormValues>();

  const influencerId = watch(['id']);
  const isEditMode = !!influencerId;

  return (
    <div className="mx-auto rounded-[inherit]">
      <div className="flex gap-6 rounded-[inherit]">
        <div className="h-max flex-1 rounded-[inherit]">
          <Form.Body className="form-container">
            {isPartner ? isEditMode ? <NoticeConnectUrl /> : <NoticeSignUpUrl /> : <NoticeUseChromeExtension />}

            <SocialAccountsSection />
            <InfluencerAccountSection />
            <InfluencerMemoSection />
            <PostsPriceSection />
            <InfluencerManagersSection />
            <PaymentInformationSection />
            <AddressInformationSection />
            <BrandContentPermissionsSection />
          </Form.Body>

          <Form.Footer>
            <ButtonSubmit title={t('Button.Save')} loading={{ status: isSubmitting, title: t('Button.Saving') }} />
          </Form.Footer>
        </div>
      </div>
    </div>
  );
};
